import React from 'react';
import { Archive as ArchiveIcon } from '@mui/icons-material';
import Button from 'screens/components/basic/Button';
// import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
import "./dailyCashSummary.scss"

const componentName = "DailyCashSummary";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none  daily-cash-summary-header">
            <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-4 col-xl-4">
                <BranchMultiSelectAutoCompleteInput
                    defaultValues={props.defaultBranch}
                    name={componentName + LOOKUP.report.common.branchName}
                    fullWidth={true}
                    autoWidth={true}
                    label="Branches"
                    floatingLabelText="Branches"
                    hintText="Branches"
                    style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                    options={props.branchOptions}
                    fieldName={'Branches'}
                    inputStyles={{ marginTop: "5px" }}
                    updateStateImmediately
                    className={"daily-cash-summary-branches"}
                />
            </div> {/* .col */}

            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mt-1 mb_xs p-0 pt-2">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><i>To receive the correct result in the following report, please close all registers with </i><strong className="danger">"Closing in Progress"</strong> <i>status.</i></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
